import React from 'react';
import { useRouting } from 'hooks/useRouting';
import * as api from 'config/api';

import UpdateDataInfo from 'components/features/UpdateDataInfo';

type NothingMessageViewProps = {
  brokers: api.GetUserBrokerResultItem[] | undefined;
  asset: api.GetAssetResult | undefined;
};

const NothingMessageView: React.FC<NothingMessageViewProps> = props => {
  const { brokers, asset } = props;
  const pushRouting = (({ pushRouting }) => (path: string) => () => {
    pushRouting({ path }, true);
  })(useRouting());

  const isNothingBroker = brokers !== undefined && brokers?.length === 0;
  const isNothingAsset = asset !== undefined && asset?.Items.length === 0;
  const clsBg = 'max-w-md rounded-lg flex flex-col bg-white p-4 mx-4';
  return (
    <div>
      {/* 証券口座登録 */}
      <div className={`${clsBg} ${isNothingBroker ? '' : 'hidden'}`}>
        <div className="flex-grow items-center font-bold text-lg text-center mb-4">
          資産情報を登録してください
        </div>
        <div className="flex-grow text-sm">
          口座を連携して自分の資産を見える化しましょう。
        </div>
        <img
          width={200}
          height={150}
          src="./static/images/renkei.png"
          alt="renkei"
          className="my-4 mx-auto"
        />
        <div
          className="w-full flex items-center justify-center flex-1 bg-tradewell rounded-lg py-2 px-4 text-white font-bold cursor-pointer"
          onClick={pushRouting('/securityaccountslink')}>
          口座・資産情報を登録する
        </div>
      </div>

      {/* データ準備中 */}
      <div
        className={`${clsBg} ${
          !isNothingBroker && isNothingAsset ? '' : 'hidden'
        }`}>
        <div className="px-4">
          <div className="flex-grow items-center justify-center font-bold text-lg text-center mb-4">
            データを準備しています
          </div>
          <UpdateDataInfo />
        </div>
        <img
          width={225}
          height={150}
          src="./static/images/loading.png"
          alt="loading"
          className="my-4 mx-auto"
        />
      </div>
    </div>
  );
};

export default NothingMessageView;
